<a class="brand" routerLink="/dashboard"><app-logo /></a>
<button type="button" class="toggle" (click)="menuToggle.emit()" [attr.aria-expanded]="menuOpen()" [attr.aria-label]="'header.menu.toggle' | translate">
    <app-icon name="menu" />
</button>
